<template>
    <div
        class="input-table"
        v-if="loaded"
    >
        <div
            v-for="(item, index) in items"
            :class="[disable(item) ? 'input-table-shadow-disabled' : 'input-table-shadow']"
            :key="index"
        >
            <div class="d-flex row align-items-center">
                <div class="col-4 border-right">
                    <input class="pl-3" :class="{'font-italic': disable(item)}" type="text" readonly="readonly" :value="item.name" />
                </div>
                <div class="col border-right">
                    <core-money-input :disabled="disable(item)" readonly :amount="item.salePrice"></core-money-input>
                </div>
                <div class="col border-right">
                    <core-basic-drop-down
                        :items="availableAmount(item)"
                        :selection.sync="item.amount"
                        :disabled="disable(item)"
                        noLabel
                    ></core-basic-drop-down>
                </div>
                <div class="col">
                    <core-money-input :disabled="disable(item)" readonly :key="subTotal(item)" :amount="subTotal(item)"></core-money-input>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <small class="ml-2 px-2 bg-danger text-white">{{ $t('reservation.details.transport.no-transport') }}</small>
    </div>
</template>

<script>
import Reservation from '@/services/hatsApi/Reservation'
export default {
  props: {
    rollingStockId: {
      type: Number,
      required: true
    },
    reservationLineId: {
      type: String | Number,
      required: false
    },
    selectedTypes: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      items: [],
      loaded: false,
      selectedAvailability: 0
    }
  },
  created () {
    this.loadTransportTypes()
  },
  methods: {
    async loadTransportTypes () {
      try {
        let filters = [
          {
            property: 'rollingStockId',
            value: this.rollingStockId
          }
        ]
        if (this.reservationLineId > 0) {
          filters.push({
            property: 'reservationLineId',
            value: this.reservationLineId
          })
        }
        const transportTypes = await Reservation.getTransportTypes(filters)
        if (transportTypes.data.success) {
          this.items = transportTypes.data.data
          this.items.forEach((transportType) => {
            // Yes the 0 has to be a string, else it will be set as undefined
            this.$set(transportType, 'amount', '0')
          })
        }
      } catch (e) {
        console.log(e)
      }
      this.setSelectedAmount()
      this.loaded = true
    },
    setSelectedAmount () {
      if (this.items.length && this.selectedTypes.length) {
        this.items.forEach((item) => {
          // Count the amount of rooms selected
          let amount = this.$_.sumBy(this.selectedTypes, (selected) => {
            if (parseInt(selected.serviceId) === parseInt(item.id)) {
              return parseInt(selected.amount)
            } else {
              return 0
            }
          })
          this.$set(item, 'amount', amount)
        })
      }
    },
    disable (item) {
      return this.availableAmount(item).length === 1
    },
    subTotal (transportType) {
      let amount = 0
      let selectedTransportType = this.items.find(item => item.id === transportType.id)
      if (selectedTransportType) {
        amount = selectedTransportType.salePrice * transportType.amount
      }
      return amount
    },
    availableAmount (transportType) {
      let amount = 0
      if (transportType.priceType.code !== 'PERSERVICE') {
        amount = parseInt(transportType.availableSeats)
      } else {
        amount = parseInt(transportType.availableCoupes)
      }
      let availableAmount = Array.from(new Array(amount), (val, index) => index + 1)
      // Prepend 0 as a value
      availableAmount.unshift(0)
      return availableAmount
    }
  },
  watch: {
    items: {
      handler (val) {
        this.$emit('amountChanged', val)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/TransportType.vue